import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AcademyCommonModule, PipesModule } from '@draeger-academy/common';
import { AcademyPresentationUiModule } from '@draeger-academy/presentation';
import { TranslateModule } from '@ngx-translate/core';
import { PageNotFoundComponent } from './page-not-found.component';

@NgModule({
    declarations: [PageNotFoundComponent],
    providers: [],
    imports: [CommonModule, AcademyCommonModule, PipesModule, AcademyPresentationUiModule, TranslateModule.forChild()],
})
export class PageNotFoundModule {
}
